export default __webpack_public_path__ + "static/media/Group 947.599ba57d.png";